import { render, staticRenderFns } from "./AuthorizationList.vue?vue&type=template&id=2d2aa506&scoped=true"
import script from "./AuthorizationList.vue?vue&type=script&lang=js"
export * from "./AuthorizationList.vue?vue&type=script&lang=js"
import style0 from "./AuthorizationList.vue?vue&type=style&index=0&id=2d2aa506&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2aa506",
  null
  
)

export default component.exports